/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_ad__magazine__generic_button = /** @type {(inputs: {}) => string} */ () => {
	return `Entdecken`
};

const en_ad__magazine__generic_button = /** @type {(inputs: {}) => string} */ () => {
	return `Discover`
};

const es_ad__magazine__generic_button = /** @type {(inputs: {}) => string} */ () => {
	return `Descubrir`
};

const fr_ad__magazine__generic_button = /** @type {(inputs: {}) => string} */ () => {
	return `Découvrir`
};

const it_ad__magazine__generic_button = /** @type {(inputs: {}) => string} */ () => {
	return `Scopri`
};

const nl_ad__magazine__generic_button = /** @type {(inputs: {}) => string} */ () => {
	return `Ontdekken`
};

const pt_ad__magazine__generic_button = /** @type {(inputs: {}) => string} */ () => {
	return `Descobrir`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ad__magazine__generic_button = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ad__magazine__generic_button(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("ad__magazine__generic_button", locale)
	if (locale === "de") return de_ad__magazine__generic_button(inputs)
	if (locale === "en") return en_ad__magazine__generic_button(inputs)
	if (locale === "es") return es_ad__magazine__generic_button(inputs)
	if (locale === "fr") return fr_ad__magazine__generic_button(inputs)
	if (locale === "it") return it_ad__magazine__generic_button(inputs)
	if (locale === "nl") return nl_ad__magazine__generic_button(inputs)
	return pt_ad__magazine__generic_button(inputs)
};